var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"wd_link",class:{
    'wd_link_right': _vm.align === 'right'
  }},[_c('div',{staticClass:"wd_link_border wd_link_border_1"}),_c('div',{staticClass:"wd_link_border wd_link_border_2"}),_c('div',{staticClass:"wd_link_border wd_link_border_3"}),_c('div',{staticClass:"wd_link_border wd_link_border_4"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }